/* 
  カートページに関わるカスタマイズを記述
  ※商品オプション制御は[custom-cart-lineitem-option-js.liquid]を参照

  - ノベルティ制御
  - 各オプションのツールチップ表示
*/

// ノベルティ制御
const applyNovelty = async () => {
  document
    .querySelectorAll(
      "input[name='ノベルティ'],input[name='ノベルティ'] + label"
    )
    .forEach((item) => {
      item.classList.add("is-disabled");
    });
  let noveltySoldOutFlg = false;
  const cartContent = await (
    await fetch(`${window.themeVariables.routes.cartUrl}.js`, {
      cache: "reload",
    })
  ).json();
  const noveltyElem = document.querySelector(
    "input[name='ノベルティ']:checked"
  );
  const noveltyItem_Price = parseInt(noveltyElem.dataset.novelty_item_price),
    noveltyItem_PriceTitle = noveltyElem.dataset.novelty_item_price_title,
    noveltyPriceCondition = parseInt(
      noveltyElem.dataset.novelty_price_condition
    ),
    noveltyItem_SKUAnyoneTitle =
      noveltyElem.dataset.novelty_item_sku_any_one_title,
    noveltyItem_SKUAnyone = parseInt(
      noveltyElem.dataset.novelty_item_sku_any_one
    ),
    noveltyItem_SKUIncludingAllTitle =
      noveltyElem.dataset.novelty_item_sku_including_all_title,
    noveltyItem_SKUIncludingAll = parseInt(
      noveltyElem.dataset.novelty_item_sku_including_all
    ),
    noveltySKUConditionList =
      noveltyElem.dataset.novelty_sku_condition === ""
        ? []
        : noveltyElem.dataset.novelty_sku_condition.split(","),
    countForNovelty = parseInt(noveltyElem.dataset.count_for_novelty),
    noveltyBrandItems =
      noveltyElem.dataset.novelty_brand_items === ""
        ? []
        : noveltyElem.dataset.novelty_brand_items.split(","),
    noveltyBrandTitle = noveltyElem.dataset.novelty_brand_title,
    totalPriceNoveltyCollection =
      noveltyElem.dataset.total_price_novelty_collection === "true";

  let includeSKUCount = 0;
  let hasBrandFlg = false;

  if (noveltyElem.classList.contains("is-soldout")) {
    return false;
  }

  // ブランド指定がある場合、ブランド商品があるかどうか？を条件に追加
  if (noveltyBrandItems.length > 0) {
    hasBrandFlg = noveltyBrandItems.some((brandItem) =>
      cartContent["items"].find((item) => item.product_id == brandItem)
    );
  }

  const removeFormData = { updates: {} }, // カートから削除するノベルティ
    addFormData = { items: [] }; // カートに追加するノベルティ
  if (noveltyElem.value.indexOf("希望する") > -1) {
    // ノベルティを希望する場合

    if (noveltyItem_Price && noveltyPriceCondition > 0) {
      // 0. ノベルティ適用を判定する金額を取得
      let judgeCurrentPrice;

      if (totalPriceNoveltyCollection && noveltyBrandItems.length > 0) {
        // 対象ブランドの商品の合計金額のみで判定
        judgeCurrentPrice = cartContent["items"]
          .filter((item) =>
            noveltyBrandItems.includes(item.product_id.toString())
          )
          .reduce((sum, item) => sum + item.original_line_price, 0);
      } else {
        // 従来通りカート全体の合計金額で判定
        judgeCurrentPrice = cartContent["original_total_price"];
      }

      // 1. 金額の条件でカート追加を行う（例；カートの合計金額がXX円以上の場合ノベルティを追加）
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_Price
      )
        ? true
        : false;

      if (
        addedNoveltyFlg === false &&
        judgeCurrentPrice >= noveltyPriceCondition * 100 &&
        (noveltyBrandItems.length === 0 || hasBrandFlg === true)
      ) {
        // ノベルティがカートに未追加 and 金額条件を満たしている場合、カート追加
        addFormData.items.push({
          id: parseInt(noveltyItem_Price),
          quantity: countForNovelty,
        });
      } else if (noveltyBrandItems.length > 0 && hasBrandFlg === false) {
        // ブランド指定があり、ブランド商品がカートにない場合、カート削除
        removeFormData.updates[noveltyItem_Price] = 0;
      } else if (
        addedNoveltyFlg === true &&
        judgeCurrentPrice < noveltyPriceCondition * 100
      ) {
        // ノベルティがカートに追加済み and 金額条件を満たしていない場合、カート削除
        removeFormData.updates[noveltyItem_Price] = 0;
      }
    }

    // 2. SKU番号で特定の商品（複数あり）がカートの中に含まれている場合、ノベルティを追加（例；カートの中にA商品またはB商品が含まれている場合追加）
    if (noveltyItem_SKUAnyone && noveltySKUConditionList.length > 0) {
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_SKUAnyone
      )
        ? true
        : false;
      // 2-1. noveltySKUConditionList[]配列の文字列のうち、条件を満たすSKUをカウント
      noveltySKUConditionList.forEach((condition) => {
        if (
          cartContent["items"].find((item) => item.sku.indexOf(condition) > -1)
        ) {
          includeSKUCount += 1;
        }
      });
      // 2-2. includeSKUCount(条件を満たすSKUのカウント数)が1以上であれば、ノベルティ条件OK
      if (addedNoveltyFlg === false && includeSKUCount >= 1) {
        // ノベルティがカートに未追加 and SKU条件を満たしている場合、カート追加
        addFormData.items.push({
          id: parseInt(noveltyItem_SKUAnyone),
          quantity: countForNovelty,
        });
      } else if (addedNoveltyFlg === true && includeSKUCount === 0) {
        // ノベルティがカートに追加済み and SKU条件を満たしていない場合、カート削除
        removeFormData.updates[noveltyItem_SKUAnyone] = 0;
      }
    }

    // 3. SKU番号で特定の商品（複数あり）がカートの中すべて含まれている場合、ノベルティを追加（例；カートの中にA商品、B商品、C商品のすべてが含まれている場合追加）
    if (noveltyItem_SKUIncludingAll && noveltySKUConditionList.length > 0) {
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_SKUIncludingAll
      )
        ? true
        : false;
      // 3-1. noveltySKUConditionList[]配列の文字列のうち、条件を満たすSKUをカウント
      noveltySKUConditionList.forEach((condition) => {
        if (
          cartContent["items"].find((item) => item.sku.indexOf(condition) > -1)
        ) {
          includeSKUCount += 1;
        }
      });
      // 3-2. includeSKUCount(条件を満たすSKUのカウント数)が全てのSKU一覧であれば、ノベルティ条件OK
      if (
        addedNoveltyFlg === false &&
        includeSKUCount === noveltySKUConditionList.length
      ) {
        // ノベルティがカートに未追加 and SKU条件を満たしている場合、カート追加
        addFormData.items.push({
          id: parseInt(noveltyItem_SKUIncludingAll),
          quantity: countForNovelty,
        });
      } else if (
        addedNoveltyFlg === true &&
        includeSKUCount !== noveltySKUConditionList.length
      ) {
        // ノベルティがカートに追加済み and SKU条件を満たしていない場合、カート削除
        removeFormData.updates[noveltyItem_SKUIncludingAll] = 0;
      }
    }
  } else {
    // ノベルティを希望しない場合
    if (noveltyItem_Price) {
      // 1. 金額条件のノベルティがカートに追加済みの場合、カートから削除
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_Price
      )
        ? true
        : false;
      if (addedNoveltyFlg === true) {
        removeFormData.updates[noveltyItem_Price] = 0;
      }
    }
    if (noveltyItem_SKUAnyone) {
      // 2. SKU条件(いずれか1つ)のノベルティがカートに追加済みの場合、カートから削除
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_SKUAnyone
      )
        ? true
        : false;
      if (addedNoveltyFlg === true) {
        removeFormData.updates[noveltyItem_SKUAnyone] = 0;
      }
    }
    if (noveltyItem_SKUIncludingAll) {
      // 3. SKU条件(全て)のノベルティがカートに追加済みの場合、カートから削除
      const addedNoveltyFlg = cartContent["items"].find(
        (item) => item.id === noveltyItem_SKUIncludingAll
      )
        ? true
        : false;
      if (addedNoveltyFlg === true) {
        removeFormData.updates[noveltyItem_SKUIncludingAll] = 0;
      }
    }
  }

  // 追加対象となるノベルティがある場合、追加処理
  if (addFormData.items.length > 0) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        dataType: "json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          // ノベルティ商品の売り切れ時
          noveltySoldOutFlg = true;
          console.error('"カートの更新に失敗しました。', data);
        } else {
          console.log(`Added ${data}`);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // 削除対象となるノベルティがある場合、削除処理
  if (Object.keys(removeFormData.updates).length > 0) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        dataType: "json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(removeFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // 更新が完了したら、ページを最新化
  const cartContentUpdated = await (
    await fetch(`${window.themeVariables.routes.cartUrl}.js`, {
      cache: "reload",
    })
  ).json();

  // カートが0件の場合はページをリロード
  if (cartContentUpdated["items"].length === 0) {
    window.location.reload();
    return false;
  }

  const priceNovelty_InUpdatedCart = cartContentUpdated["items"].find(
      (item) => item.id === noveltyItem_Price
    ),
    sKUAnyone_InUpdatedCart = cartContentUpdated["items"].find(
      (item) => item.id === noveltyItem_SKUAnyone
    ),
    sKUIncludingAll_InUpdatedCart = cartContentUpdated["items"].find(
      (item) => item.id === noveltyItem_SKUIncludingAll
    );

  // 1. ノベルティのアラート表示
  let noveltyRemainingHTML = "";
  let hiddenCheckboxFlg = false;
  let novelty_InUpdatedCart = null;
  if (noveltyItem_Price && noveltyPriceCondition > 0) {
    if (!priceNovelty_InUpdatedCart) {
      // 0. ノベルティ適用を判定する金額を取得
      let currentPrice;

      if (totalPriceNoveltyCollection && noveltyBrandItems.length > 0) {
        // 対象ブランドの商品の合計金額のみ
        currentPrice = cartContentUpdated["items"]
          .filter((item) =>
            noveltyBrandItems.includes(item.product_id.toString())
          )
          .reduce((sum, item) => sum + item.original_line_price, 0);
      } else {
        // カート全体の合計金額
        currentPrice = cartContentUpdated["original_total_price"];
      }

      const remainingAmountValue = Math.floor(
        (noveltyPriceCondition * 100 - currentPrice) / 100
      );
      if (noveltyBrandItems.length > 0 && hasBrandFlg === false) {
        // ブランド指定があり、ブランド商品がカートにない場合、ノベルティ条件未達成
        noveltyRemainingHTML += `<li>ノベルティ対象商品を追加いただくと、ノベルティが選択可能になります</li>`;
        hiddenCheckboxFlg = true;
      } else if (remainingAmountValue > 0) {
        noveltyRemainingHTML += `<li>あと、${
          noveltyBrandTitle.length > 0 ? `${noveltyBrandTitle}商品を` : ""
        }${remainingAmountValue.toLocaleString()}円の購入でノベルティをお選びいただけます</li>`;
        hiddenCheckboxFlg = true;
      } else {
        noveltyRemainingHTML += `ノベルティのご希望の場合は、希望するにチェックを入れてください。`;
      }
    } else {
      novelty_InUpdatedCart = priceNovelty_InUpdatedCart;
    }
  }
  if (noveltyItem_SKUAnyone && noveltySKUConditionList.length > 0) {
    if (!sKUAnyone_InUpdatedCart) {
      let includeSKUCount = 0;
      noveltySKUConditionList.forEach((condition) => {
        if (
          cartContentUpdated["items"].find(
            (item) => item.sku.indexOf(condition) > -1
          )
        ) {
          includeSKUCount += 1;
        }
      });
      if (includeSKUCount > 0) {
        noveltyRemainingHTML += `ノベルティのご希望で、${noveltyItem_SKUAnyoneTitle}を追加できます`;
      } else {
        noveltyRemainingHTML += `<li>ノベルティ対象商品を追加いただくと、ノベルティが選択可能になります</li>`;
        hiddenCheckboxFlg = true;
      }
    } else {
      novelty_InUpdatedCart = sKUAnyone_InUpdatedCart;
    }
  }
  if (noveltyItem_SKUIncludingAll && noveltySKUConditionList.length > 0) {
    if (!sKUIncludingAll_InUpdatedCart) {
      let includeSKUCount = 0;
      noveltySKUConditionList.forEach((condition) => {
        if (
          cartContentUpdated["items"].find(
            (item) => item.sku.indexOf(condition) > -1
          )
        ) {
          includeSKUCount += 1;
        }
      });
      if (includeSKUCount === noveltySKUConditionList.length) {
        noveltyRemainingHTML += `ノベルティのご希望で、${noveltyItem_SKUIncludingAllTitle}を追加できます`;
      } else {
        noveltyRemainingHTML += `<li>ノベルティ対象商品を追加いただくと、ノベルティが選択可能になります</li>`;
        hiddenCheckboxFlg = true;
      }
    } else {
      novelty_InUpdatedCart = sKUIncludingAll_InUpdatedCart;
    }
  }
  document.getElementById("novelty-remaining").innerHTML = noveltyRemainingHTML;

  // 2. ノベルティの条件を満たしていない場合、チェックボックスを非表示
  if (hiddenCheckboxFlg === true) {
    document
      .getElementById("novelty-radio-container")
      .setAttribute("hidden", "true");
  } else {
    document
      .getElementById("novelty-radio-container")
      .removeAttribute("hidden");
  }

  // ノベルティの希望をメモ
  const noveltyDesireFormData = {
    attributes: {
      ノベルティの希望: `${noveltyElem.value}${
        hiddenCheckboxFlg === true ? "(条件未達成)" : ""
      }`,
    },
  };
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      dataType: "json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(noveltyDesireFormData),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });

  // 3. カートの合計
  let cartTotalPrice = Math.floor(cartContentUpdated.total_price / 100);
  document.getElementById(
    "cart-total-price"
  ).textContent = `¥${cartTotalPrice.toLocaleString()}`;

  // 4. 送料無料表示/プログレスバー
  const totalPrice = cartContentUpdated["items"]
    .filter((item) => item["requires_shipping"])
    .reduce((sum, item) => sum + item["original_line_price"], 0);
  const freeShippingBarElem = document.querySelector("free-shipping-bar");
  const threshold = parseFloat(freeShippingBarElem.getAttribute("threshold"));
  freeShippingBarElem.style.setProperty(
    "--progress",
    Math.min(totalPrice / threshold, 1)
  );
  if (totalPrice >= threshold) {
    document.querySelector(".shipping-bar__text").textContent =
      "送料無料です！";
  } else {
    const remainingAmount = Math.floor((threshold - totalPrice) / 100);
    document.querySelector(
      ".shipping-bar__text"
    ).textContent = `残り${remainingAmount.toLocaleString()}円で送料無料！`;
  }

  // 5. ノベルティの数量とカートのノベルティ商品の数量が合わない場合、数量を調整
  if (
    novelty_InUpdatedCart &&
    novelty_InUpdatedCart.quantity !== countForNovelty
  ) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        dataType: "json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: novelty_InUpdatedCart.key,
        quantity: countForNovelty,
      }),
    });
  }

  if (noveltySoldOutFlg !== true) {
    document
      .querySelectorAll(
        "input[name='ノベルティ'],input[name='ノベルティ'] + label"
      )
      .forEach((item) => {
        item.classList.remove("is-disabled");
      });
  } else {
    // ノベルティ商品の売り切れ時処理
    document
      .querySelectorAll(
        "input[name='ノベルティ'],input[name='ノベルティ'] + label"
      )
      .forEach((item) => {
        item.classList.add("is-soldout");
      });
    document.getElementById("novelty-remaining").innerHTML =
      "<li>ノベルティが規定数量に達したため、配布を終了しました</li>";
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // ノベルティが有効な場合、処理を実施
  if (document.querySelectorAll("input[name='ノベルティ']").length > 0) {
    applyNovelty();

    document
      .querySelectorAll("input[name='ノベルティ']")
      .forEach((noveltyRadio) => {
        noveltyRadio.addEventListener("change", (event) => {
          applyNovelty();
        });
      });
  } else {
    let updateFlg = false;
    let formData = {};
    // 1. カートにノベルティ商品がある場合、自動削除
    const removeNoveltyElem = document.querySelector(
      "[data-remove_novelty_list]"
    );
    const removeNoveltyList =
      removeNoveltyElem.dataset.remove_novelty_list === ""
        ? []
        : removeNoveltyElem.dataset.remove_novelty_list.split(",");
    if (removeNoveltyList.length > 0) {
      updateFlg = true;
      formData["attributes"] = {};
      formData["updates"] = {};
      formData["attributes"]["ノベルティの希望"] = null;
      removeNoveltyList.forEach((removeItem) => {
        formData["updates"][removeItem] = 0;
      });
    }

    // 2. ノベルティが無効、かつAttributeにノベルティの希望がある場合、削除
    if (document.querySelector("[data-disabled_novelty]")) {
      // ノベルティが無効、かつAttributeにノベルティの希望がある場合、削除
      updateFlg = true;
      formData["attributes"] = {};
      formData["attributes"]["ノベルティの希望"] = null;
    }

    // 1.と2.の結果を反映
    if (updateFlg === true) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          dataType: "json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }
});

// 各オプションのツールチップを表示
const dipsTooltip = (obj) => {
  if (obj.getAttribute("area-expand") === "true") {
    obj.setAttribute("area-expand", "false");
    document.querySelector(".c-option-tooltip").remove();
    document.querySelector(".c-option-tooltip__background").remove();
  } else {
    obj.setAttribute("area-expand", "true");
    const tooltipId = obj.getAttribute("data-tooltip_id");
    const tooltipInnerHTML = document.getElementById(tooltipId).innerHTML;
    obj.insertAdjacentHTML(
      "afterend",
      `
    <div class="c-option-tooltip">
      ${tooltipInnerHTML}
    </div>
    <div class="c-option-tooltip__background" onclick="closeToolTip()"></div>
    `
    );
  }
};
const closeToolTip = () => {
  const openingTooltipBtn = document.querySelector(
    '.c-option-tooltip__toggle[area-expand="true"]'
  );
  openingTooltipBtn.setAttribute("area-expand", "false");
  document.querySelector(".c-option-tooltip").remove();
  document.querySelector(".c-option-tooltip__background").remove();
};
